import React from 'react';

import { Typography, Button } from '../../../../components';

export const MissingOrInvalidFiles = ({ error, resetForm }) => {
    return (
        <div className="missing-or-invalid-files">
            {error.message}
            <div className="button-group">
                <Button type="primary" size="medium" onClick={resetForm}>
                    Start Over
                </Button>
            </div>
        </div>
    );
};
